export default __webpack_public_path__ + "d6f4cdca09c2f7a0cedc248cfc4fda62.svg";